import { lazy, Suspense } from "react";
import { FileQuestion } from "lucide-react";
import { FileKind, describeLimit, getFileKind } from "../lib/fileTypes";
import { LoadingViewer } from "./renderers/Common";

interface ViewerProps {
  file: File;
  zoom: number;
}

const PdfViewer = lazy(() => import("./renderers/PdfViewer"));
const DocxViewer = lazy(() => import("./renderers/DocxViewer"));
const SheetViewer = lazy(() => import("./renderers/SheetViewer"));
const PptxViewer = lazy(() => import("./renderers/PptxViewer"));
const TextViewer = lazy(() => import("./renderers/TextViewer"));
const ImageViewer = lazy(() => import("./renderers/ImageViewer"));

export function DocumentViewer({ file, zoom }: ViewerProps) {
  const kind = getFileKind(file);
  const fallback = <LoadingViewer label="뷰어 여는 중" />;

  if (kind === "pdf") {
    return (
      <Suspense fallback={fallback}>
        <PdfViewer file={file} zoom={zoom} />
      </Suspense>
    );
  }

  if (kind === "docx") {
    return (
      <Suspense fallback={fallback}>
        <DocxViewer file={file} zoom={zoom} />
      </Suspense>
    );
  }

  if (kind === "sheet") {
    return (
      <Suspense fallback={fallback}>
        <SheetViewer file={file} zoom={zoom} />
      </Suspense>
    );
  }

  if (kind === "pptx") {
    return (
      <Suspense fallback={fallback}>
        <PptxViewer file={file} zoom={zoom} />
      </Suspense>
    );
  }

  if (kind === "text") {
    return (
      <Suspense fallback={fallback}>
        <TextViewer file={file} zoom={zoom} />
      </Suspense>
    );
  }

  if (kind === "image") {
    return (
      <Suspense fallback={fallback}>
        <ImageViewer file={file} zoom={zoom} />
      </Suspense>
    );
  }

  return <UnsupportedViewer file={file} kind={kind} />;
}

function UnsupportedViewer({ file, kind }: { file: File; kind: FileKind }) {
  return (
    <div className="empty-state compact">
      <div className="empty-icon">
        <FileQuestion size={30} />
      </div>
      <h2>{file.name}</h2>
      <p>{describeLimit(kind)}</p>
    </div>
  );
}
